import React, { useState } from "react";
import { X, Globe } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Geordende "Selectie website" — verslepen om te herordenen, X om te verwijderen.
export default function WebsiteSelectionGrid({ requestId, selection, onChanged }) {
    const [dragIdx, setDragIdx] = useState(null);
    const [overIdx, setOverIdx] = useState(null);
    const [busy, setBusy] = useState(false);

    const save = async (urls, msg) => {
        setBusy(true);
        try {
            await api.post(`/requests/${requestId}/website-selection`, { urls });
            toast.success(msg);
            onChanged?.();
        } catch (e) {
            toast.error(e.response?.data?.detail || "Opslaan mislukt");
        }
        setBusy(false);
    };

    const handleDrop = (targetIdx) => {
        const from = dragIdx;
        setDragIdx(null);
        setOverIdx(null);
        if (from === null || from === targetIdx || busy) return;
        const arr = [...selection];
        const [m] = arr.splice(from, 1);
        arr.splice(targetIdx, 0, m);
        save(arr, "Volgorde aangepast");
    };

    if (!selection || selection.length === 0) {
        return (
            <div className="text-sm text-zinc-500 italic py-6 text-center border border-dashed border-zinc-200 rounded-sm" data-testid="website-selection-empty">
                Nog geen foto's in de Selectie website.<br />
                <span className="text-xs">Ga naar "Alle foto's" en klik op het <Globe className="h-3 w-3 inline" />-icoon op de beste foto's.</span>
            </div>
        );
    }

    return (
        <>
            <p className="text-[11px] text-zinc-400 mb-2" data-testid="website-selection-hint">
                Dit is wat makelaars eerst zien op de deelpagina. Versleep om te herordenen — de beste eerst.
            </p>
            <div className="grid grid-cols-3 md:grid-cols-5 gap-2" data-testid="website-selection-grid">
                {selection.map((u, i) => (
                    <div
                        key={`${u}-${i}`}
                        className={`relative aspect-square rounded-sm overflow-hidden border group transition ${dragIdx === i ? "opacity-40 border-zinc-200" : overIdx === i && dragIdx !== null ? "border-[#E5A93D] ring-2 ring-[#E5A93D]/50" : "border-zinc-200"} ${busy ? "pointer-events-none opacity-60" : ""}`}
                        draggable={selection.length > 1}
                        onDragStart={() => setDragIdx(i)}
                        onDragOver={(e) => { e.preventDefault(); setOverIdx(i); }}
                        onDragLeave={() => setOverIdx((v) => (v === i ? null : v))}
                        onDrop={(e) => { e.preventDefault(); handleDrop(i); }}
                        onDragEnd={() => { setDragIdx(null); setOverIdx(null); }}
                        data-testid={`website-selection-tile-${i}`}
                    >
                        <img src={`${BACKEND}${u}`} alt={`selectie ${i + 1}`} loading="lazy" className="w-full h-full object-cover" />
                        <span className="absolute bottom-1 left-1 text-[10px] font-bold bg-black/60 text-white rounded-sm px-1.5 h-5 inline-flex items-center">{i + 1}</span>
                        <button
                            type="button"
                            onClick={() => save(selection.filter((x) => x !== u), "Foto uit selectie gehaald")}
                            className="absolute top-1 right-1 h-6 w-6 inline-flex items-center justify-center bg-black/70 hover:bg-red-600 text-white rounded-sm opacity-0 group-hover:opacity-100 transition"
                            title="Verwijder uit Selectie website (foto blijft in de fotoreeks)"
                            data-testid={`website-selection-remove-${i}`}
                        >
                            <X className="h-3.5 w-3.5" />
                        </button>
                    </div>
                ))}
            </div>
        </>
    );
}
